/**
 * 多指触控
 * Create by liaokai on 2020-04-20 12:00:37
 */
import * as React from 'react';
import {Component, HTMLAttributes} from "react";
import {Touch} from "react";

interface IProps extends HTMLAttributes<HTMLDivElement>{
    minTrigger : number,
    onTrigger? : (touches : Touch[]) => void
}

interface IState{
    list : any[]
}

export class MultiTouch extends Component<IProps,IState>{
    readonly state : IState = {
        list : []
    };

    static defaultProps : IProps = {
        minTrigger : 5
    };

    render() {
        let {onTrigger,children, minTrigger} = this.props;
        let {list} = this.state;

        return (
            <div
                {...this.props}
                onTouchStart={event => {
                    let a : Touch[] = [];
                    for(let i=0;i<event.touches.length; i++){
                        let item = event.touches[i];
                        a.push(item)
                    }
                    if(a.length >= minTrigger){
                        onTrigger?.(a);
                        this.setState({list : a.map(value => ({x : value.pageX, y : value.pageY}))})
                    }
                }}
                // onTouchEnd={event => {
                //     this.setState({})
                // }}
            >
                {/*{JSON.stringify(list)}*/}
                {children}
            </div>
        );
    }
}
